'use strict'

/**
* 键名为字符的hashmap存储
* 贷款类型 lend 01定期贷款 02循环贷款
* 贷款id application_id 
* 本地ip createdIp
* 经度 createdLongitude
* 纬度 createdLatitude
* 区域 createdAddress
*/
const map = {
    '_map': {},
    'has': key => !!map._map[key.toString()],
    'get': key => map._map[key.toString()],
    'set': (key, value) => (map._map[key.toString()] = value)
};

export default map;



// WEBPACK FOOTER //
// ./src/assets/dbs/hashmap.js